export default {
  getMoreFamilyList: state => state.familyList
};
